import { SchoolSharp } from "react-ionicons";

export default function Logo() {
  return (
    <div>
      <SchoolSharp
        color={"#b2b6b8"}
        height="40px"
        width="40px"
        style={{ cursor: "pointer" }}
      />
      <h1>RepoProvas</h1>
    </div>
  );
}
